import {Button} from '@mui/material';
import {useCallback, useState} from 'react';
import StatusNoteDialog from '../StatusNoteDialog/StatusNoteDialog';

export interface QuestionFormStatusNoteDialogProps {
  statusNote: string;
  disabled?: boolean;
}

export default function QuestionFormStatusNoteDialog({
  statusNote,
  disabled = false,
}: QuestionFormStatusNoteDialogProps) {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const isDisabled = disabled || !statusNote || statusNote.trim().length === 0;

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleOpen}
        disabled={isDisabled}
        sx={{
          borderColor: '#1B263B',
          color: '#1B263B',
          '&:hover': {borderColor: '#1B263B', bgcolor: '#1B263B', color: 'white'},
        }}
      >
        Notes
      </Button>

      <StatusNoteDialog open={open} onClose={handleClose} statusNote={statusNote} />
    </>
  );
}
